module.exports = __webpack_public_path__ + "static/media/nine.dc5aa927.svg";